import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
import { 
// TreeSelect,
Select, Tooltip, Icon, Spin } from "@h3/antd-vue";
import { deepCopy } from '@cloudpivot/form/utils';
let RelevanceFormDropdown = class RelevanceFormDropdown extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.list = [];
        this.isShowAll = false;
        this.searchTimeoutRef = null;
        this.page = 1;
        this.loadedAll = false; // 全部数据加载完成
        this.fetching = false;
        this.currentSeachValue = '';
        this.historySeachList = [];
    }
    // 返回搜索字段之前的文字
    preHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(0, index);
    }
    // 返回搜索字段之后的文字
    nextHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(index + currentSeachValue.length);
    }
    // 设置高亮文字
    setHighlightText(value) {
        if (!this.currentSeachValue) { // 没有搜索返回原值
            return value;
        }
        let first = this.preHighlightText(value, this.currentSeachValue);
        let last = this.nextHighlightText(value, this.currentSeachValue);
        if (this.currentSeachValue === value) {
            return `<font>${this.currentSeachValue}</font>`;
        }
        if (!first && !last) {
            return value;
        }
        return `${first}<font>${this.currentSeachValue}</font>${last}`;
    }
    get selectedId() {
        if (this.ctrl.value) {
            return this.ctrl.value.id || undefined;
        }
        return undefined;
    }
    get selectedItem() {
        if (this.selectedId && this.list.length === 0) {
            return this.parseDisplayFieldValue(this.ctrl.value[this.getDisplayField], this.getDisplayField);
        }
        return "";
    }
    get drowdownList() {
        if (this.list.length) {
            let arr = [];
            for (let val of this.list) {
                if (val[this.getDisplayField] !== null && val[this.getDisplayField] !== '') {
                    let value = this.parseDisplayFieldValue(val[this.getDisplayField], this.getDisplayField);
                    arr.push({
                        id: val.id,
                        [this.getDisplayField]: value
                    });
                }
            }
            return arr;
        }
        else {
            return [];
        }
    }
    setControl() {
        super.setControl();
        if (this.selectedId) {
            this.onFocus();
        }
    }
    onFocus() {
        this.search("");
    }
    onSearch(value) {
        clearTimeout(this.searchTimeoutRef);
        this.searchTimeoutRef = setTimeout(() => {
            this.list = [];
            this.search(value);
        }, 300);
    }
    // 保存历史最近10个查询记录
    saveHistorySeach() {
        let value = this.currentSeachValue;
        if (value === undefined || value === '') {
            return;
        }
        let index = this.historySeachList.indexOf(value);
        if (index !== -1) {
            this.historySeachList.splice(index, 1);
        }
        else {
            if (this.historySeachList.length >= 10) { // 历史查询记录大于10个，删除一个老数据
                this.historySeachList.pop();
            }
        }
        this.historySeachList.unshift(value);
        localStorage.setItem((this.ctrl.id), JSON.stringify(this.historySeachList));
    }
    // 删除历史记录
    delHistoryItem(item, obj) {
        let index = this.historySeachList.indexOf(item);
        if (index !== -1) {
            this.historySeachList.splice(index, 1);
            localStorage.setItem((this.ctrl.id), JSON.stringify(this.historySeachList));
            // const historyObj = document.querySelector('.history-'+ obj) // 双向数据绑定不能触发弹窗中的修改，使用操作dom的方式删除
            // historyObj && historyObj.remove()
        }
    }
    popupScroll($ev) {
        if ($ev.target.scrollHeight < $ev.target.offsetHeight + $ev.target.scrollTop + 64) {
            // 滚动到底||加载全部数据
            if (this.fetching || this.loadedAll) {
                return;
            }
            this.page++;
            this.search(this.currentSeachValue, this.page);
        }
    }
    search(value, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!page) {
                this.page = 0;
            }
            this.currentSeachValue = value; // 记录最后一次加载
            if (this.queryConditions.length === 0 && this.controlOpts.conditions) {
                const res = yield this.getConfig();
                if (res && res.conditions) {
                    this.queryConditions = res.conditions;
                }
            }
            if (this.fetching) {
                return;
            }
            this.fetching = true;
            // this.list = [];
            this.fetch(page === undefined ? 0 : page, 1000, value).then(seg => {
                this.fetching = false;
                if (page) {
                    this.list = [...this.list, ...seg.data];
                }
                else {
                    this.list = seg.data;
                }
                this.loadedAll = seg.total == this.list.length;
            }, () => (this.fetching = false));
        });
    }
    onChange(selectedId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (selectedId) {
                this.saveHistorySeach(); // 记录历史搜索条件
                let item = this.list.find(x => x.id === selectedId);
                item = yield this.convertForMappings(item);
                // this.ctrl.value = item;
                this.interceptorValue(item);
                this.setValue(item);
                setTimeout(() => {
                    this.setValue(deepCopy(item));
                }, 500);
            }
            else {
                this.ctrl.value = null;
            }
        });
    }
    mounted() {
        const historySeachList = localStorage.getItem((this.ctrl.id));
        if (historySeachList) {
            this.historySeachList = JSON.parse(historySeachList);
        }
        else {
            this.historySeachList = [];
        }
    }
};
RelevanceFormDropdown = tslib_1.__decorate([
    Component({
        name: "relevance-form-dropdown",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
            // ATreeSelect: TreeSelect,
            // ATreeSelectNode: TreeSelect.TreeNode,
            AIcon: Icon,
            ASpin: Spin,
            VNodes: {
                functional: true,
                render: (h, ctx) => ctx.props.vnodes,
            },
        }
    })
], RelevanceFormDropdown);
export default RelevanceFormDropdown;
